<template>
  <div class="main">
    <div class="viewport">
      <transition name="fade" mode="out-in">
        <router-view @show="showLoading" @hide="hideLoading"></router-view>
      </transition>
    </div>
    <div class="loading" v-show="loading">
      <img src="../assets/images/loading.svg">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false
    }
  },
  methods: {
    setCookie (name, value) {
      var Hours = 4
      var date = new Date()
      date.setTime(date.getTime() + Hours * 60 * 60 * 1000)
      document.cookie = name + '=' + value + ';expires=' + date.toGMTString()
    },
    showLoading () {
      this.loading = true
    },
    hideLoading () {
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
  /* 动画 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }

  .main {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: url("../assets/images/loginbg.jpg") center center no-repeat;
    background-size: cover;
    .viewport {
      width: 594px;
      height: 420px;
      background: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -210px 0 0 -297px;
      /* 公用样式开始 */
      .logo {
        margin: 54px 0 15px;
        text-align: center;
        img {
          width: 200px;
        }
      }
      .input {
        width: 380px;
        margin: 0 auto;
        .input-vp {
          border: 1px solid #ccc;
          height: 44px;
          display: flex;
          .icon {
            display: block;
            height: 100%;
            width: 20px;
            margin: {
              left: 20px;
              right: 10px;
            }
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
            &:first-child {
              background-image: url("../assets/images/icon_user@2x.png");
            }
          }
          &:not(:last-child) {
            border-bottom: none;
          }
          &:not(:first-child) {
            .icon {
              background-image: url("../assets/images/password@2x.png");
            }
          }
          .input-view {
            height: 100%;
            width: 320px;
            border:none;
            font-size: 16px;
            outline: none;
          }
          .rememberpw {
            width: 22px;
            height: 21px;
            margin-top: 10px;
            margin-left: -22px;
            cursor: pointer;
          }
        }
      }
      .btn {
        width: 300px;
        height: 44px;
        margin: 40px auto 30px;
        border-radius: 5px;
        background: green;
        color: #fff;
        font-size: 18px;
        line-height: 44px;
        text-align: center;
        cursor: pointer;
      }
      .choose {
        text-align: center;
        font-size: 16px;
        .link {
          cursor: pointer;
          color: #888;
          text-decoration: none;
          margin: {
            left: 15px;
            right: 15px;
          }
          &:hover {
            color: #00A7FF;
          }
        }

      }
      .change {
        width: 88px;
        height: 88px;
        position: absolute;
        right: 0;
        bottom: 0;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
      .back {
        width: 57px;
        height: 57px;
        position: absolute;
        top: 40px;
        left: 30px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
      .title {
        height: 60px;
        font-size: 40px;
        text-align: center;
        color: #888;
        margin: {
          top: 40px;
          bottom: 30px;
        }
      }
      .user-argreement {
        text-align: center;
        color: #888;
        font-size: 14px;
      }
      /* 公用样式结束 */
      .qrlogin {
        .qrcode {
          margin: 70px auto 50px;
          width: 240px;
          height: 240px;
          img {
            width: 100%;
          }
        }
        .tips {
          text-align: center;
          font-size: 20px;
          color: #888;
        }
      }
      .signup,.forgot {
        .input {
          .input-vp:first-child {
            .icon {
              background-image: url("../assets/images/email@2x.png");
            }
          }
        }
      }
      .forgot {
        .btn {
          margin-top: 88px;
        }
      }
      @media screen and (max-width: 760px) {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: auto;
        height: auto;

        .input {
          width: 90%;
          margin: 0 auto;
        }
        .btn {
          max-width: 80%;
        }
        .title {
          font-size: 32px;
        }
        .user-argreement {
          text-align:center;
          margin: 0 auto;
          max-width: 80%;
        }
      }
    }

  }

  /* loading */
  .loading {
    position: fixed;
    z-index: 999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(200,200,200,.1);

  }
</style>



// WEBPACK FOOTER //
// Main.vue?ae82fe7c